module.exports = __webpack_public_path__ + "static/media/ic_close_p.6df42da0.svg";